// Root mutations
function initialState() {
  return { user: null, auth: {}, isLogged: false }
}

export default {
  INCREMENT(state) {
    state.count++
  },

  RESET_STORE(state) {
    const newState = initialState()
    state = Object.assign(state, newState)
  },

  /**
   * Set current application layout
   * @param state
   * @param payload
   * @constructor
   */
  SET_LAYOUT(state, payload) {
    state.layout = payload
  },

  // Logout from application. Set values to local storage
  LOGOUT() {
    localStorage.isLogged = 0
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
    localStorage.removeItem('expires_in')
    localStorage.removeItem('logged_at')
    localStorage.removeItem('logged_user')
  },

  // Login into app. Set values to local storage
  LOGIN(state, payload) {
    localStorage.setItem('isLogged', 1)
    localStorage.setItem('access_token', payload.access_token)
    localStorage.setItem('refresh_token', payload.refresh_token)
    localStorage.setItem('expires_in', payload.expires_in)
    localStorage.setItem('logged_at', new Date())
    localStorage.setItem('logged_user', JSON.stringify(payload.user))
  },

  // Change flag in state
  SET_IS_LOGGED_FLAG(state, value) {
    state.isLogged = value
  },

  // Populate auth data from state
  POPULATE_AUTH_AT_STATE(state) {
    state.auth = {
      accessToken: localStorage.getItem('access_token'),
      refreshToken: localStorage.getItem('refresh_token'),
      expiresIn: localStorage.getItem('expires_in'),
      loggedAt: localStorage.getItem('logged_at')
    }
  },

  // Change user in state
  SET_USER(state, value) {
    state.user = value
    localStorage.setItem('logged_user', JSON.stringify(state.user))
  },

  // Snackbar notification
  SET_NOTIFICATION(state, notification) {
    state.notification = notification
  },

  // Set refresh request
  REFRESH_REQUEST(state, request) {
    state.refreshRequest = request
  },

  // Set refresh request
  SET_TEST_USER(state, value) {
    state.testUser = value
  },

  SET_BEAMS_USER(state, value) {
    state.beamsUser = value
  },

  SET_APP_VERSION(state, value) {
    state.version = value
  }
}
